import React, { useRef, useEffect } from "react";
import ReactHtmlParser from 'react-html-parser';
import "./orderItem.css";
import "./button.css";
import { withTranslation } from "react-i18next";
import { getProductVariation, cartLocal } from "../../actions/productActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ComboProductList from "./ComboProduct/comboProductList";

const URL = process.env.REACT_APP_API_BASE_IMG;
const OrderItem = (props) => {
  const data = props.data;
  const imgRefs = useRef([]);
  imgRefs.current = [];

  // Add to cart function using data[key] only
  const addDirectToCart = (key) => {
    const product = props.data.product[key];

    let currentCart = JSON.parse(localStorage.getItem("cart") || "[]");

    const existingIndex = currentCart.findIndex(item => item.product_id === product.id);

    if (existingIndex !== -1) {
      currentCart[existingIndex].quantity += 1;
      currentCart[existingIndex].price = parseFloat(product.price) * currentCart[existingIndex].quantity;
    } else {
      // Generate unique cartID
      let cartID = parseInt(localStorage.getItem("cartID") || "0", 10) + 1;
      localStorage.setItem("cartID", cartID);

      // Prepare cart item
      const cartItem = {
        ...product,
        id: cartID,
        product_id: product.id,
        product_name: product.name,
        product_price: parseFloat(product.price),
        quantity: 1,
        price: parseFloat(product.price),
        variation_id: (product.variation_id).toString(),
        variation_name: "",
        variation_quantity: "",
        variation_set_id: "",
        variation_price: [],
        printed: 0,
      };

      currentCart.push(cartItem);
    }
    localStorage.setItem("cart", JSON.stringify(currentCart));

    // Update Redux
    props.cartLocal(currentCart);
    if (props.updateCart) props.updateCart(currentCart);

    // Fly-to-cart animation
    if (window.flyToCart && imgRefs.current[key]) {
      window.flyToCart({ current: imgRefs.current[key] });
    }
  };

  const renderProduct = () => {
    let html = [];

    if (props.data.product && Object.keys(props.data.product).length > 0) {

      let data = props.data.product;

      Object.keys(data).forEach(function (key) {
        const item = data[key];
        const isNotForSelling =
          Number(item.out_of_stock) === 1;
        html.push(
          <div key={key} className="col-xl-6 ">
            <div className="box">
              {/* --- */}
              {/* {isNotForSelling && (
                <div className="not-selling-badge">Not For Selling</div>
              )} */}
              <div
                className={`row ${isNotForSelling ? "no-click-all" : ""}`}
                style={{ cursor: isNotForSelling ? "not-allowed" : "default" }}
              >
                <div className="col-6 product-img-wrapper">
                  {isNotForSelling && (
                    <div className="not-selling-cross">Out of Stock</div>
                  )}
                  <img
                    ref={(el) => (imgRefs.current[Number(key)] = el)}
                    className={`item-img ${isNotForSelling ? "img-gray" : ""}`}
                    src={(data && data[key].image) || '/images/default_placeholder.png'}
                    onError={(e) => { e.target.onerror = null; e.target.src = '/images/default_placeholder.png'; }}
                    alt="product"
                  />
                </div>

                <div className="col-6 cnts">
                  <div className="head">
                    <h3>{data && data[key].name}</h3>
                  </div>
                  <div className="dec">
                    {data[key].product_description != null
                      ? ReactHtmlParser(data[key].product_description)
                      : null}
                  </div>
                  <div className="action">
                    <div className="price" style={{ marginLeft: "0px" }}>
                      From <span>$ {data && parseFloat(data[key].price).toFixed(2)}</span>
                    </div>
                    {(Number(data[key].out_of_stock) === 1) ? (
                      <button className="btn primary btn-item btn-gray no-click" disabled>
                        Add
                      </button>
                    ) : props.AddToCaetrestrict ? (
                      <button className="btn primary btn-disabled" disabled>
                        Add
                      </button>
                    ) : data[key].combo_products?.length > 0 ? (
                      <button
                        onClick={() => props.showChooseModal(data[key])}
                        data-toggle="modal"
                        data-target="#cartModal"
                        className="btn primary btn-item"
                        data-testid={`${data[key].id}_combo_modal`}
                      >
                        Add
                      </button>
                    ) : (
                      // No restriction → decide based on modifier counts
                      data[key].product_modifier_count === 0 || data[key].product_modifier_count_delivery === 0 ? (
                        <button
                          onClick={() => addDirectToCart(key)}
                          className="btn primary btn-item"
                          data-testid={`${data[key].id}_direct_add`}
                        >
                          Add
                        </button>
                      ) : (
                        <button
                          onClick={() => props.showChooseModal(data[key])}
                          data-toggle="modal"
                          data-target="#cartModal"
                          className="btn primary btn-item"
                          data-testid={`${data[key].id}_modal`}
                        >
                          Add
                        </button>
                      ))

                    }
                  </div>
                </div>
              </div>
              {/* --- */}
            </div>
          </div>
        );
      });
    }
    return html;
  };

  return <div className="row">{renderProduct()}</div>;
};

OrderItem.propTypes = {
  showChooseModal: PropTypes.func.isRequired,
  updateCart: PropTypes.func,
  cartLocal: PropTypes.func.isRequired,
};

export { OrderItem }


const mapStateToProps = (state) => ({
  variation: state.products.variation
});
export default withTranslation()(
  connect(mapStateToProps, { getProductVariation, cartLocal })(OrderItem)
);
